<template>
<div>
  <div class="header1" v-if="loggedin">
    <h4>Users</h4>
    <v-btn outlined rounded text dark class="foota" style="float:right;" @click="editItem(0)">New User</v-btn>
    <v-dialog
      v-model="newbuild"
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <validation-observer
                ref="observer"
              >
                <form @submit.prevent="submit" class="form">
                  <i>User Name : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="User Name"
                    rules="required"
                  >
                    <v-text-field
                      v-model="editedItem.user_name"
                      :error-messages="errors"
                      required
                      solo dark autocomplete="nope"
                      color="whitesmoke"
                    ></v-text-field>
                  </validation-provider>

                  <i>Password : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <v-text-field
                        v-model="editedItem.password"
                        :error-messages="errors"
                        required
                        solo autocomplete="nope"
                        dark color="whitesmoke"
                    ></v-text-field>
                  </validation-provider>

                  <i>Active : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Active"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.active"
                        :items="status"
                        :error-messages="errors"
                        required
                        solo autocomplete="nope"
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>Admin : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Admin"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.admin"
                        :items="status"
                        :error-messages="errors"
                        required
                        solo autocomplete="nope"
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>RMX1971 : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="RMX1971"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.rmx1971"
                        :items="status"
                        :error-messages="errors"
                        required autocomplete="nope"
                        solo
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>r5x : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="r5x"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.r5x"
                        :items="status"
                        :error-messages="errors"
                        required autocomplete="nope"
                        solo
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>Even : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Even"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.even"
                        :items="status"
                        :error-messages="errors"
                        required autocomplete="nope"
                        solo
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>Action on builds : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Action on builds"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.actions_on_builds"
                        :items="status"
                        :error-messages="errors"
                        required autocomplete="nope"
                        solo
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>Actions on blogs : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Actions on blogs"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.actions_on_blogs"
                        :items="status"
                        :error-messages="errors"
                        required autocomplete="nope"
                        solo
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <i>Actions on Maintainers : </i>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Actions on Maintainers"
                    rules="required"
                  >
                    <v-select
                        v-model="editedItem.actions_on_maintainers"
                        :items="status"
                        :error-messages="errors"
                        required autocomplete="nope"
                        solo
                        dark color="whitesmoke"
                    ></v-select>
                  </validation-provider>

                  <v-btn
                    outlined rounded text dark color="error" style="margin:3%"
                    @click="newbuild=false"
                  >
                    Close
                  </v-btn>

                  <v-btn
                    outlined rounded text dark color="success" style="margin:3%"
                    type="submit"
                    @click="save()"
                  >
                    Save
                  </v-btn>
                </form>
              </validation-observer>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="delete1"
      max-width="600px"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <validation-observer
                ref="observer"
              >
                <form class="form" style="font-size:16px;">
                  <i>Do you wish to delete {{ editedItem.user_name }}?</i>
                  <p></p>
                  <i>Id of Build is {{ editedIndex }}</i>
                  <p></p>
                  <v-btn
                    outlined rounded text dark style="margin:3%"
                    @click="delete1=false"
                  >
                    Close
                  </v-btn>

                  <v-btn
                    outlined rounded text dark color="error" style="margin:3%"
                    @click="deleteBuild()"
                  >
                    Delete
                  </v-btn>
                </form>
              </validation-observer>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <v-alert class="latestbuilds1" type="success" v-if="added">User Added Successfully.</v-alert>
  <v-alert class="latestbuilds1" type="error" v-if="failadd">Failed to Add User.</v-alert>
  <v-alert class="latestbuilds1" type="success" v-if="updated">Updated User Successfully.</v-alert>
  <v-alert class="latestbuilds1" type="error" v-if="failupdate">Failed to Update User.</v-alert>
  <v-alert class="latestbuilds1" type="error" v-if="deletedbuild">User Deleted Successfully.</v-alert>
  <v-alert class="latestbuilds1" type="error" v-if="faileddeletebuild">Failed to Delete User.</v-alert>
  <div v-if="loggedin && userdata.length != 0" class="latestbuilds">
    <div v-for="user in userdata" :key="user" class="latestbuild">
      <v-card
        class="mx-auto build"
        max-width="400"
        min-height="275"
        outlined
        dark
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              {{ user.user_name }}
            </v-list-item-title>
            <v-list-item-subtitle v-if="user.rmx1971 == 'Y' || user.r5x == 'Y' || user.even == 'Y'"><strong>Device : </strong> 
              <i v-if="user.rmx1971 == 'Y'">Realme 5 Pro</i>
              <i v-if="user.rmx1971 == 'Y' && user.r5x == 'Y'">, </i>
              <i v-if="user.r5x == 'Y'">Realme 5 Series</i>
              <i v-if="user.rmx1971 == 'Y' && user.even == 'Y' || user.r5x == 'Y' && user.even == 'Y'">, </i>
              <i v-if="user.even == 'Y'">Realme C25 Series</i>
            </v-list-item-subtitle>
            <v-list-item-subtitle><strong>Active : </strong>  
              <i v-if="user.active == 'Y'">Yes</i>
              <i v-else>No</i>
            </v-list-item-subtitle>
            <v-list-item-subtitle><strong>Admin : </strong>  
              <i v-if="user.admin == 'Y'">Yes</i>
              <i v-else>No</i>
            </v-list-item-subtitle>
            <v-list-item-subtitle><strong>Action On Builds : </strong>  
              <i v-if="user.actions_on_builds == 'Y'">Yes</i>
              <i v-else>No</i>
            </v-list-item-subtitle>
            <v-list-item-subtitle><strong>Action On Blogs : </strong>  
              <i v-if="user.actions_on_blogs == 'Y'">Yes</i>
              <i v-else>No</i>
            </v-list-item-subtitle>
            <v-list-item-subtitle><strong>Action On Maintainers : </strong>  
              <i v-if="user.actions_on_maintainers == 'Y'">Yes</i>
              <i v-else>No</i>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-actions >
          <v-btn
            outlined
            rounded
            text
            class="foota" color="success"
             @click="editItem(user)"
          >
            Edit
          </v-btn>
          <v-btn
            outlined
            rounded
            text
            class="foota"
            v-if="data['admin'] == 'Y'" color="error"
             @click="deleteItem(user)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
  <div v-if="loadingdata && userdata.length == 0" class="header2" style="margin-top:8%;">
    <v-progress-circular
      :rotate="180"
      :size="100"
      :width="15"
      :value="value"
      color="blue"
    >
      {{ value }}
    </v-progress-circular>
  </div>
  <div v-if="nodata && !loadingdata || !loggedin && !loadingdata" class="header2" style="margin-top:8%;">
    <img src="../assets/404.png" alt="404(Not Found)">
      <h1>404</h1>
      <p>No Data Found</p>
  </div>
</div>
</template>

<script>
import { required, min } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios';
import { VueEditor } from "vue2-editor"; 

  setInteractionMode('eager')
  
  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })
  
  extend('min', {
    ...min,
    message: '{_field_} must have atlest {length} characters',
  })

export default {
    name: 'Users',
    components: {
      ValidationProvider,
      ValidationObserver,
      VueEditor,
    },
    data: () => ({
      show: false,
      loggedin : false,
      userdata : [],
      newbuild: false,
      status: ['Y', 'N'],
      editedItem: [],
      editedIndex: [],
      title : null,
      loadingdata: false,
      nodata: false,
      dialog: false,
      updated: false,
      failupdate: false,
      added: false,
      failadd: false,
      interval: {},
      value: 10,
      delete1 : false,
      deletedbuild: false,
      faileddeletebuild: false,
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted () {
      this.interval = setInterval(() => {
        if (this.value === 100) {
          return (this.value = 0)
        }
        this.value += 10
      }, 1000)
    },
    created () {
      this.checkloggedin();
      this.getusers();
    },

    methods: {
      checkloggedin() {
        this.current_time = Math.round(+new Date()/1000);
        if (sessionStorage.getItem("token") && sessionStorage.getItem("expire_time") > this.current_time) {
          this.data = JSON.parse(sessionStorage.getItem('data'));
          if (this.data['admin'] != 'Y') {
            this.loggedin = false;
          } else {
            this.loggedin= true;
          }
        } else {
          sessionStorage.clear();
          this.loggedin = false;
        }
      },
      getusers() {
        let config = {
        method : 'get',
        url : `https://kharame-devices.herokuapp.com/users`,
        headers: {
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        }
        };
        this.loadingdata=true;
        axios(config)
        .then((response) => {
        this.userdata  = response.data.message;
          if (this.userdata  ) {
              this.loadingdata = false;
              this.nodata = false;
          } else {
              setTimeout(() => { this.loadingdata = false; }, 1000);
              setTimeout(() => { this.nodata = true; }, 1000);
          }
        })
      },
      editItem (item) {
        this.editedIndex = this.userdata.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.newbuild = true;
        if (item == 0) {
          this.title = 'New Build'
        } else {
          this.title = 'Edit '+item.name
        }
      },
      deleteItem (item) {
        this.editedIndex = this.userdata.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.delete1 = true;
      },
      deleteBuild () {
        let data = {
            table : 'users',
            id : this.editedItem.id,
        };
        let config = {
            method : 'post',
            url : `https://kharame-devices.herokuapp.com/delete`,
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            data : data
        };
        axios(config)
        .then((response) => {
            if (response.data && response.data.status === "S" && response.data.message === "S") {
              this.deletedbuild = true;
              this.updated = false;
              this.failupdate = false;
              this.added = false;
              this.failadd = false;
              this.faileddeletebuild = false;
              this.getusers();
            } else {
              this.faileddeletebuild = true;
              this.deletedbuild = false;
              this.updated = false;
              this.failupdate = false;
              this.added = false;
              this.failadd = false;
            }
        })
        this.delete1 = false;
      },
     save () {
        if (!this.editedItem.user_name) {
          alert('Please enter Username.')
        } else if (!this.editedItem.password){
          alert('Please enter Password.')
        } else if (!this.editedItem.active) {
          alert('Please fill Active Status.')
        } else if (!this.editedItem.admin) {
          alert('Please fill Admin Status.')
        } else if (!this.editedItem.rmx1971) {
          alert('Please fill RMX1971 Status.')
        } else if (!this.editedItem.r5x) {
          alert('Please fill r5x Status.')
        } else if (!this.editedItem.even) {
          alert('Please fill EVEN Status.')
        } else if (!this.editedItem.actions_on_builds) {
          alert('Please fill Action on Builds Status.')
        } else if (!this.editedItem.actions_on_blogs) {
          alert('Please fill Action on Blog Status.')
        } else if (!this.editedItem.actions_on_maintainers) {
          alert('Please fill Action on Maintainers Status.')
        } else {
          if (this.editedIndex > -1) {
              let config = {
                  method : 'post',
                  url : `https://kharame-devices.herokuapp.com/updateuser`,
                  headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                  },
                  data: this.editedItem
              };
              axios(config)
              .then((response) => {
                  if (response.data && response.data.status === "S" && response.data.message === "S") {
                    this.updated = true;
                    this.failupdate = false;
                    this.added = false;
                    this.failadd = false;
                    this.getusers();
                  } else {
                    this.updated = false;
                    this.failupdate = true;
                    this.added = false;
                    this.failadd = false;
                  }
              })
          } else {
              let config = {
                  method : 'post',
                  url : `https://kharame-devices.herokuapp.com/createuser`,
                  headers: {
                  'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                  },
                  data: this.editedItem
              };
              axios(config)
              .then((response) => {
                  if (response.data && response.data.status === "S" && response.data.message === "S") {
                    this.updated = false;
                    this.failupdate = false;
                    this.added = true;
                    this.failadd = false;
                    this.getusers();
                  } else {
                    this.updated = false;
                    this.failupdate = false;
                    this.added = false;
                    this.failadd = true;
                  }
              })        
          }
          this.newbuild = false;
        }
      },
    },
  }
</script>
<style scoped>
.header1 {
  margin-top:8%;
  width:88%;
  text-align: center;
}
.form {
  padding:5%;
  color:whitesmoke;
}
.ql-editor {
  background:red !important;
}
.header2 {
  margin-top:2%;
  text-align: center;
  margin-bottom : 5%;
}
.v-dialog__content{
  margin-top:3%;
}
.v-card{
  background: rgba(23,25,33,255) !important;
  color: whitesmoke !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
}
.latestbuilds {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 88%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom :2%;
}
.latestbuilds1 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 55%;
  margin-left: auto;
  margin-right: auto;
  margin-top:5%;
  margin-bottom :2%;
}
.latestbuild {
  margin : 2%;
}
.build {
  background: rgba(23,25,33,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6) !important;
}
.v-timeline-item__body a {
  color:whitesmoke;
  text-decoration : none;
}
.v-list-item__content .v-list-item__subtitle{
  color :whitesmoke !important;
  font-size: 14px;
  padding:1%;
}
.foota:hover {
  text-decoration: none;
}

@media (max-width: 1000px) {
  .header1 {
    margin-top: 10%;
  }
  .latestbuilds1 {
    display: block;
  }
  .v-dialog__content{
    margin-top:6%;
  }
}
@media (max-width: 550px) {
  .header1 {
    margin-top: 18%;
  }
  .latestbuilds {
    margin-bottom : 12%;
  }
  .latestbuilds1 {
    width:85%;
  }
  .v-dialog__content{
    margin-top:9%;
  }
}

</style>